import { createContext, useContext, useEffect, useState } from 'react';
import { auth as coreAuth } from '@sitebuilder/core';
import { userManager } from './oidcConfig';

interface AuthContextType {
    user: coreAuth.User | null;
    login: ({ state }: { state?: any }) => Promise<void>;
    logout: () => Promise<void>;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider = (props: { children: React.ReactNode; user?: coreAuth.User }) => {
    const [user, setUser] = useState<coreAuth.User | null>(props.user || null);

    useEffect(() => {
        userManager.getUser().then((u) => setUser(u));
        userManager.events.addUserLoaded(setUser);
        userManager.events.addUserUnloaded(() => setUser(null));

        return () => {
            userManager.events.removeUserLoaded(setUser);
            userManager.events.removeUserUnloaded(() => setUser(null));
        };
    }, []);

    const login = ({ state }: { state?: any }) => userManager.signinRedirect({ state });
    const logout = () => userManager.signoutRedirect();

    return (
        <AuthContext.Provider value={{ user, login, logout }}>
            {props.children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};
